import React, { useRef } from "react";
import { CircularProgress, DialogContent, DialogTitle } from "@material-ui/core";
import styles from "scenarios/_css/scenariosPage.module.css";
import { scenariosStore } from "scenarios/_stores/scenariosStore";
import { toast } from "react-toastify";
import fileIcon from "../assets/icons/file.svg";
import { useTranslation } from "react-i18next";
import { useLoadingFromPromise } from "common/loaders/useLoadingFromPromise";

export const ScenarioDialogImport = ({ setOpenImportModal }: { setOpenImportModal: (v: boolean) => void }) => {
    const { t } = useTranslation();
    const fileInputRef = useRef<HTMLInputElement>(null);
    const { loading, setPromise } = useLoadingFromPromise();

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file) return;

        const promise = scenariosStore
            .import(file)
            .then(() => toast.info(t("scenariosPage.import"), { position: "bottom-center" }))
            .catch(() => toast.error("Erreur lors de l'import.", { position: "bottom-center" }))
            .finally(() => setOpenImportModal(false));

        setPromise(promise);
    };

    const isLoading = loading?.status === "LOADING";

    return (
        <>
            <DialogTitle>
                <span className={styles.title}>{t("scenariosPage.importHistory")}</span>
            </DialogTitle>
            <DialogContent>
                {isLoading ? (
                    <div className={styles.loadingContainer} style={{ textAlign: "center", padding: "20px" }}>
                        <CircularProgress />
                    </div>
                ) : (
                    <div
                        className={styles.importContainer}
                        onClick={() => fileInputRef.current?.click()}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") fileInputRef.current?.click();
                        }}
                        aria-label="Envoyer votre fichier zip"
                    >
                        <img src={fileIcon} title={"ZIP"} alt="ZIP" className={styles.fileIcon} />
                        <p>{t("scenariosPage.sendFile")}</p>
                        <input
                            ref={fileInputRef}
                            type="file"
                            accept=".zip"
                            onChange={handleFileChange}
                            disabled={isLoading}
                        />
                    </div>
                )}
            </DialogContent>
        </>
    );
};
